import React, { Component } from "react";
import axios from "axios";
import { admission, arit, mua, site, unwrapApiList } from "../config/api";

import MetaTags from "react-meta-tags";
import Swal from "sweetalert2";
import {
  HiOutlineAcademicCap,
  HiOutlineArrowLeft,
  HiOutlineArrowRight,
  HiOutlineCalendarDays,
  HiOutlineIdentification,
} from "react-icons/hi2";
import NewsList from "../Components/NewsList";
import RegisterRounds from "../Components/RegisterRounds";
import "./Register.css";

export default class Register extends Component {


  constructor(props) {
    super(props);
    this.state = {
      robId: "",
      nation: "",
      nation_name: "",
      citizent: "",
      checked: false,
      screenWidth: 0,
      screenWidthcard: 0,
      countnews: 0,
      open: 0,

      array_Nation: [],
      array_robId: [],
      news: [],
      loadingRob: true,
      loadingNews: true,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleRobChange = this.handleRobChange.bind(this);
    this.handleNationChange = this.handleNationChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.chkdate = this.chkdate.bind(this);
  }

  componentDidMount() {
    // ประเภทนักศึกษา
    // "1" ระดับปริญญาตรี ปกติ
    // "2" ระดับปริญญาตรี กศ.บป.
    // "3" ระดับปริญญาโท
    // "4" ระดับปริญญาเอก
    // "5" ระดับ ป.วิชาชีพครู
    const d = new Date().getDate();
    const stop = 28;
    if (d > stop) {
      this.setState({ open: 1 });
      // console.log(d);
      console.log("เปิด");
    } else {
      this.setState({ open: 0 });
      console.log("ปิด");
    }
    localStorage.clear();
    if (this.props.match.params.param === "0") {
      localStorage.setItem("robId", "141");
    }
    if (window.screen.width < 1600) {
      this.setState({ screenWidthcard: "100%" });
    } else {
      this.setState({ screenWidthcard: window.screen.width * 0.5 });
    }
    if (window.screen.width < 1500) {
      this.setState({ screenWidth: 240 });
    } else {
      this.setState({ screenWidth: window.screen.width * 0.15 });
    }

    // axios.get(admission + "/administrator_new/show/"+ this.props.match.params.param).then((res) => {
    axios
      .get(
        admission + "/administrator_new/shownewsBee/" +
        this.props.match.params.param
      )
      .then((res) => {
        this.setState({ countnews: res.data.length });
        this.setState({ news: res.data });
      })
      .catch(() => {
        this.setState({ countnews: 0, news: [] });
      })
      .finally(() => {
        this.setState({ loadingNews: false });
      });
    let id;
    if (this.props.match.params.param === "0") {
      id = "0";
    } else {
      id = this.props.match.params.param;
    }
    axios
      .get(
        mua + "/admissionnew2022/showrobregister/" +
        // this.props.match.params.param
        id
      )
      .then((rob) => {
        console.log(id);
        const list = rob?.data?.data?.data;
        if (!Array.isArray(list)) {
          console.error("showrobregister: unexpected response", rob?.data);
          this.setState({ array_robId: [] });
          return;
        }
        var i = 0;
        var today = "";
        today = new Date().getFullYear();
        if (new Date().getMonth() + 1 < 10) {
          today = today + "-0" + (new Date().getMonth() + 1);
        } else {
          today = today + "-" + (new Date().getMonth() + 1);
        }
        if (new Date().getDate() < 10) {
          today = today + "-0" + new Date().getDate();
        } else {
          today = today + "-" + new Date().getDate();
        }
        while (i < list.length) {
          const startdate = new Date(list[i]["ROB_OPEN"]).toLocaleDateString(
            "th-TH",
            {
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          );
          const stopdate = new Date(list[i]["ROB_CLOSE"]).toLocaleDateString(
            "th-TH",
            {
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          );
          list[i]["startdate"] = startdate;
          list[i]["stopdate"] = stopdate;
          if (today === list[i]["ROB_CLOSE"]) {
            list[i]["checkdate"] = true;
          }
          if (
            list[i]["ROB_ID"] === "90" ||
            list[i]["ROB_ID"] === "91" ||
            list[i]["ROB_ID"] === "94"
          ) {
            list[i]["checkdate"] = false;
          }
          i++;
        }
        this.setState({ array_robId: list });
        console.log(list);
      })
      .catch((err) => {
        console.error("showrobregister failed", err);
        this.setState({ array_robId: [] });
      })
      .finally(() => {
        this.setState({ loadingRob: false });
      });
    this.setState({
      array_Nation: [
        {
          value: "XX,ไม่มีสัญชาติ",
          label: "ไม่มีสัญชาติ",
          labelEN: "NO Nationality",
        },
        { value: "TH,ไทย", label: "ไทย", labelEN: "Thai" },
        { value: "CN,จีน", label: "จีน", labelEN: "China" },
        { value: "LA,ลาว", label: "ลาว", labelEN: "Lao" },
        { value: "MY,มาเลเซีย", label: "มาเลเซีย", labelEN: "Malasia" },
        { value: "MM,พม่า", label: "พม่า", labelEN: "Myanmar" },
        { value: "KH,กัมพูชา", label: "กัมพูชา", labelEN: "Cambodian" },
        { value: "ZZ,", label: "อื่นๆ", labelEN: "Other" },
      ],
    });
  }

  handleClick(event) {
    event.preventDefault();
    const el = event.currentTarget;
    const name = el.getAttribute("name");
    const id = el.getAttribute("id");
    if (name && id) {
      this.setState({ [name]: id });
    }
  }

  handleRobChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleNationChange(event) {
    event.preventDefault();
    var splitnation = event.target.value.split(",");
    this.setState({ [event.target.name]: splitnation[0] });
    this.setState({ nation_name: splitnation[1] });
  }

  handleChange(event) {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCheck(event) {
    this.setState({ [event.target.name]: event.target.checked });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.nation === "TH") {
      if (this.state.citizent.length === 13) {
        axios
          .get(
            admission +
            "/dashboard/checkCitizent/" +
            // admission + "/dashboard/checkCitizent/" +
            this.state.citizent
          )
          .then((res) => {
            if (res.data === 1) {
              localStorage.setItem("citizent", this.state.citizent);
              localStorage.setItem("typestudent", this.props.match.params.param);
              localStorage.setItem("nation", this.state.nation);
              localStorage.setItem("nation_name", this.state.nation_name);
              let headers = new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
              });
              axios
                .post(
                  mua + "/admissionnew2022/showcheckrobregister/",
                  {
                    robId: this.state.robId,
                    nation: this.state.nation,
                    nation_name: this.state.nation_name,
                    citizent: this.state.citizent,
                  },
                  { headers: headers }
                )
                .then((response) => {
                  if (this.props.match.params.param === "5") {
                    localStorage.setItem("token", response.data.data.auth);
                    localStorage.setItem("robId", this.state.robId);
                    if (response.data.data.data.length !== 0) {
                      if (response.data.data.data[0].status_register !== 0) {
                        axios
                          .get(
                            arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                            } else {
                              window.location.href =
                                arit + "/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(
                                  site + "/Dataregister"
                                );
                            }
                          });
                      } else {
                        axios
                          .get(
                            arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister`;
                            } else {
                              window.location.href =
                                arit + "/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(
                                  site + "/" +
                                  "admission/Checkvutregister"
                                );
                            }
                          });
                      }
                    } else {
                      axios
                        .get(
                          arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                          this.state.citizent +
                          "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                        )
                        .then((checkdata) => {
                          if (checkdata.data.length !== 0) {
                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister`;
                          } else {
                            window.location.href =
                              arit + "/ap/account/?nu=pdpaAgree&code=" +
                              btoa(this.state.citizent) +
                              "&status=" +
                              btoa(3) +
                              "&url=" +
                              btoa(
                                site + "/" +
                                "admission/Checkvutregister"
                              );
                          }
                        });
                    }
                  } else {
                    if (response.data.data.data.length !== 0) {
                      localStorage.setItem("token", response.data.data.auth);
                      localStorage.setItem("robId", this.state.robId);
                      const headers = {
                        "Content-Type": "application/json",
                        Authorization: `Basic ${response.data.data.auth}`,
                      };
                      axios
                        .get(
                          mua + "/admissionnew2022/showcheckvut",
                          { headers }
                        )
                        .then((checkvut) => {
                          const vutRows = unwrapApiList(checkvut && checkvut.data);
                          if (vutRows.length !== 0) {
                            localStorage.setItem(
                              "level",
                              vutRows[0]["LEVEL_EDU_ID"]
                            );
                            localStorage.setItem("plan", vutRows[0]["PLAN_ID"]);
                            localStorage.setItem(
                              "vga",
                              vutRows[0]["LEVEL_MEMBER_VGA"]
                            );
                          }
                          console.log(response);
                          if (response.data.data.data[0].status_register !== 0) {
                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                            axios
                              .get(
                                arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                                this.state.citizent +
                                "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                              )
                              .then((checkdata) => {
                                if (checkdata.data.length !== 0) {
                                  // window.location.href =
                                  //   "/Dataregister";
                                } else {
                                  window.location.href =
                                    arit + "/ap/account/?nu=pdpaAgree&code=" +
                                    btoa(this.state.citizent) +
                                    "&status=" +
                                    btoa(3) +
                                    "&url=" +
                                    btoa(
                                      site + "/" +
                                      "admission/Dataregister"
                                    );
                                }
                              });
                          } else {
                            // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/admission/Checkvutregister`;
                            axios
                              .get(
                                arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                                this.state.citizent +
                                "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                              )
                              .then((checkdata) => {
                                if (checkdata.data.length !== 0) {
                                  window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister`;
                                } else {
                                  window.location.href =
                                    arit + "/ap/account/?nu=pdpaAgree&code=" +
                                    btoa(this.state.citizent) +
                                    "&status=" +
                                    btoa(3) +
                                    "&url=" +
                                    btoa(
                                      site + "/admission/Checkvutregister"
                                    );
                                }
                              });
                          }
                        })
                        .catch(() => {
                          const alreadyRegistered =
                            unwrapApiList(response && response.data).length !== 0 &&
                            unwrapApiList(response && response.data)[0].status_register !== 0;
                          window.location.href = `${process.env.REACT_APP_BASENAME || ""}/${
                            alreadyRegistered ? "Dataregister" : "Checkvutregister"
                          }`;
                        });
                    } else {
                      localStorage.setItem("token", response.data.data.auth);
                      localStorage.setItem("robId", this.state.robId);
                      // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/admission/Checkvutregister`;
                      axios
                        .get(
                          arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                          this.state.citizent +
                          "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                        )
                        .then((checkdata) => {
                          if (checkdata.data.length !== 0) {
                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister`;
                          } else {
                            window.location.href =
                              arit + "/ap/account/?nu=pdpaAgree&code=" +
                              btoa(this.state.citizent) +
                              "&status=" +
                              btoa(3) +
                              "&url=" +
                              btoa(
                                site + "/" +
                                "admission/Checkvutregister"
                              );
                          }
                        });
                    }
                  }
                });
            } else {
              Swal.fire("เลขบัตรประชาชนไม่ถูกต้อง", "กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง", "error");
            }
          });
      }
    } else {
      localStorage.setItem("citizent", this.state.citizent);
      localStorage.setItem("typestudent", this.props.match.params.param);
      localStorage.setItem("nation", this.state.nation);
      localStorage.setItem("nation_name", this.state.nation_name);
      let headers = new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      });
      axios
        .post(
          mua + "/admissionnew2022/showcheckrobregister/",
          {
            robId: this.state.robId,
            nation: this.state.nation,
            nation_name: this.state.nation_name,
            citizent: this.state.citizent,
          },
          { headers: headers }
        )
        .then((response) => {
          if (this.props.match.params.param === "5") {
            localStorage.setItem("token", response.data.data.auth);
            localStorage.setItem("robId", this.state.robId);
            if (response.data.data.data.length !== 0) {
              if (response.data.data.data[0].status_register !== 0) {
                axios
                  .get(
                    arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                    this.state.citizent +
                    "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                  )
                  .then((checkdata) => {
                    if (checkdata.data.length !== 0) {
                      window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                    } else {
                      window.location.href =
                        arit + "/ap/account/?nu=pdpaAgree&code=" +
                        btoa(this.state.citizent) +
                        "&status=" +
                        btoa(3) +
                        "&url=" +
                        btoa(site + "/Dataregister");
                    }
                  });
              } else {
                axios
                  .get(
                    arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                    this.state.citizent +
                    "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                  )
                  .then((checkdata) => {
                    if (checkdata.data.length !== 0) {
                      window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formprofile`;
                    } else {
                      window.location.href =
                        arit + "/ap/account/?nu=pdpaAgree&code=" +
                        btoa(this.state.citizent) +
                        "&status=" +
                        btoa(3) +
                        "&url=" +
                        btoa(
                          site + "/admission/Checkvutregister"
                        );
                    }
                  });
              }
            } else {
              axios
                .get(
                  arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                  this.state.citizent +
                  "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                )
                .then((checkdata) => {
                  if (checkdata.data.length !== 0) {
                    window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister`;
                  } else {
                    window.location.href =
                      arit + "/ap/account/?nu=pdpaAgree&code=" +
                      btoa(this.state.citizent) +
                      "&status=" +
                      btoa(3) +
                      "&url=" +
                      btoa(site + "/Checkvutregister");
                  }
                });
            }
          } else {
            if (response.data.data.data.length !== 0) {
              localStorage.setItem("token", response.data.data.auth);
              localStorage.setItem("robId", this.state.robId);
              const headers = {
                "Content-Type": "application/json",
                Authorization: `Basic ${response.data.data.auth}`,
              };
              axios
                .get(mua + "/admissionnew2022/showcheckvut", {
                  headers,
                })
                .then((checkvut) => {
                  const vutRows = unwrapApiList(checkvut && checkvut.data);
                  if (vutRows.length !== 0) {
                    localStorage.setItem("level", vutRows[0]["LEVEL_EDU_ID"]);
                    localStorage.setItem("plan", vutRows[0]["PLAN_ID"]);
                    localStorage.setItem("vga", vutRows[0]["LEVEL_MEMBER_VGA"]);
                  }
                  if (response.data.data.data[0].status_register !== 0) {
                    window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                    axios
                      .get(
                        arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                        } else {
                          window.location.href =
                            arit + "/ap/account/?nu=pdpaAgree&code=" +
                            btoa(this.state.citizent) +
                            "&status=" +
                            btoa(3) +
                            "&url=" +
                            btoa(
                              site + "/Dataregister"
                            );
                        }
                      });
                  } else {
                    // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/admission/Checkvutregister`;
                    axios
                      .get(
                        arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister`;
                        } else {
                          window.location.href =
                            arit + "/ap/account/?nu=pdpaAgree&code=" +
                            btoa(this.state.citizent) +
                            "&status=" +
                            btoa(3) +
                            "&url=" +
                            btoa(
                              site + "/Checkvutregister"
                            );
                        }
                      });
                  }
                })
                .catch(() => {
                  const alreadyRegistered =
                    unwrapApiList(response && response.data).length !== 0 &&
                    unwrapApiList(response && response.data)[0].status_register !== 0;
                  window.location.href = `${process.env.REACT_APP_BASENAME || ""}/${
                    alreadyRegistered ? "Dataregister" : "Checkvutregister"
                  }`;
                });
            } else {
              localStorage.setItem("token", response.data.data.auth);
              localStorage.setItem("robId", this.state.robId);
              // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/admission/Checkvutregister`;
              axios
                .get(
                  arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                  this.state.citizent +
                  "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                )
                .then((checkdata) => {
                  if (checkdata.data.length !== 0) {
                    window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkvutregister`;
                  } else {
                    window.location.href =
                      arit + "/ap/account/?nu=pdpaAgree&code=" +
                      btoa(this.state.citizent) +
                      "&status=" +
                      btoa(3) +
                      "&url=" +
                      btoa(site + "/Checkvutregister");
                  }
                });
            }
          }
        });
    }
  }
  chkdate(robclose) {
    const closedate = new Date(robclose + " 23:59");
    const today = new Date();
    const result = closedate >= today ? "yes" : "no";
    console.log(result);
    console.log(closedate);
    console.log(today);
    return result;
  }

  getPageTitle() {
    const map = {
      "0": "สมัครเรียนประกาศนียบัตรผู้ช่วยพยาบาล",
      "1": "สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์)",
      "2": "สมัครเรียนปริญญาตรีภาค กศ.บป. (เสาร์-อาทิตย์)",
      "3": "สมัครเรียนระดับบัณฑิตวิทยาลัย",
      "4": "สมัครเรียนระดับบัณฑิตวิทยาลัย",
      "5": "สมัครเรียนประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู",
    };
    return map[this.props.match.params.param] || "สมัครเรียนออนไลน์";
  }

  clearRob = (event) => {
    event.preventDefault();
    this.setState({
      robId: "",
      nation: "",
      nation_name: "",
      citizent: "",
      checked: false,
    });
  };

  render() {
    const param = this.props.match.params.param;
    const selectedRob = this.state.robId > 0;
    const title = this.getPageTitle();

    return (
      <>
        <MetaTags>
          <title>รอบการเปิดรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="รอบการเปิดรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="รอบการเปิดรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>

        <div className="reg-page">
          <div className="reg-hero">
            <p className="reg-hero__eyebrow">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
            <h1 className="reg-hero__title">
              <HiOutlineAcademicCap size={28} aria-hidden />
              {title}
            </h1>
            <p className="reg-hero__desc">
              {selectedRob
                ? "กรอกสัญชาติและเลขบัตรประชาชนเพื่อเริ่มสมัคร"
                : "เลือกช่วงรอบที่ต้องการสมัครก่อน แล้วกรอกข้อมูลยืนยันตัวตน"}
            </p>
          </div>

          <div className="reg-steps" aria-label="ขั้นตอนการสมัคร">
            <div className={`reg-step${selectedRob ? " is-done" : " is-active"}`}>
              <span className="reg-step__num" aria-hidden="true">
                <HiOutlineCalendarDays size={14} />
              </span>
              เลือกรอบสมัคร
            </div>
            <div className={`reg-step${selectedRob ? " is-active" : ""}`}>
              <span className="reg-step__num" aria-hidden="true">
                <HiOutlineIdentification size={14} />
              </span>
              กรอกข้อมูลยืนยันตัวตน
            </div>
          </div>

          <div className="reg-panel">
            <form className="reg-form" onSubmit={this.handleSubmit}>
              {selectedRob ? (
                <>
                  <button type="button" className="reg-back" onClick={this.clearRob}>
                    <HiOutlineArrowLeft size={16} aria-hidden />
                    เปลี่ยนรอบสมัคร
                  </button>
                  <h2 className="reg-panel__title">
                    <HiOutlineIdentification size={20} aria-hidden />
                    ยืนยันตัวตนผู้สมัคร
                  </h2>
                  <p className="reg-panel__hint">กรอกข้อมูลให้ครบถ้วนก่อนเริ่มกรอกใบสมัคร</p>

                  <div className="form-outline">
                    <label className="form-label" htmlFor="nation">
                      สัญชาติ (Nationality)
                    </label>
                    <select
                      className="form-control"
                      id="nation"
                      name="nation"
                      onChange={this.handleNationChange}
                      required
                    >
                      <option value="" hidden>
                        ---ระบุสัญชาติ (Nationality)---
                      </option>
                      {this.state.array_Nation.map((data) => (
                        <option key={data.value} value={data.value}>
                          {data.label} ({data.labelEN})
                        </option>
                      ))}
                    </select>
                  </div>

                  {this.state.nation !== "" ? (
                    <>
                      {this.state.nation === "TH" ? (
                        <div className="form-outline">
                          <label className="form-label" htmlFor="citizent">
                            รหัสเลขบัตรประชาชน
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="citizent"
                            name="citizent"
                            placeholder="รหัสเลขบัตรประชาชน 13 หลัก"
                            maxLength="13"
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                      ) : this.state.nation === "ZZ" ? (
                        <>
                          <div className="form-outline">
                            <label className="form-label" htmlFor="nation_name">
                              ชื่อสัญชาติ
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="nation_name"
                              name="nation_name"
                              placeholder="กรุณาระบุสัญชาติ"
                              value={this.state.nation_name}
                              onChange={this.handleChange}
                              required
                            />
                          </div>
                          <div className="form-outline">
                            <label className="form-label" htmlFor="citizent">
                              รหัสเลขบัตรประชาชน / Passport / บัตรยืนยันตัวตน
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="citizent"
                              name="citizent"
                              placeholder="รหัสเลขบัตรประชาชน/เลขบัตร Passport"
                              onChange={this.handleChange}
                              required
                            />
                          </div>
                        </>
                      ) : (
                        <div className="form-outline">
                          <label className="form-label" htmlFor="citizent">
                            รหัสเลขบัตรประชาชน / เลขบัตร Passport
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="citizent"
                            name="citizent"
                            placeholder="รหัสเลขบัตรประชาชน/เลขบัตร Passport"
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                      )}

                      <div className="reg-check">
                        <input
                          type="checkbox"
                          id="vehicle1"
                          name="checked"
                          onChange={this.handleCheck}
                        />
                        <label htmlFor="vehicle1">
                          ข้าพเจ้ายืนยันว่าได้ศึกษาข้อมูลหลักสูตร สาขาวิชา และคณะที่เปิดรับสมัคร
                          จากเอกสารข้างต้นเรียบร้อยแล้ว
                        </label>
                      </div>
                    </>
                  ) : null}

                  <div className="form-outline">
                    {this.state.nation === "TH" ? (
                      this.state.nation_name !== "" &&
                      this.state.citizent.length === 13 &&
                      this.state.checked ? (
                        <button type="submit" className="reg-submit">
                          <HiOutlineArrowRight size={18} aria-hidden />
                          เริ่มกรอกข้อมูลสมัคร
                        </button>
                      ) : (
                        <button type="submit" className="reg-submit" disabled>
                          <HiOutlineArrowRight size={18} aria-hidden />
                          เริ่มกรอกข้อมูลสมัคร
                        </button>
                      )
                    ) : this.state.nation_name !== "" &&
                      this.state.citizent !== "" &&
                      this.state.checked ? (
                      <button type="submit" className="reg-submit">
                        <HiOutlineArrowRight size={18} aria-hidden />
                        เริ่มกรอกข้อมูลสมัคร
                      </button>
                    ) : (
                      <button type="submit" className="reg-submit" disabled>
                        <HiOutlineArrowRight size={18} aria-hidden />
                        เริ่มกรอกข้อมูลสมัคร
                      </button>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <h2 className="reg-panel__title">
                    <HiOutlineCalendarDays size={20} aria-hidden />
                    เลือกรอบที่ต้องการสมัคร
                  </h2>
                  <p className="reg-panel__hint">
                    กดที่รอบที่เปิดรับสมัคร (รอบที่ปิดจะแสดงจางกว่าและกดไม่ได้)
                  </p>

                  <RegisterRounds
                    param={param}
                    loading={this.state.loadingRob}
                    rounds={this.state.array_robId}
                    selectedRobId={this.state.robId}
                    onSelect={this.handleClick}
                  />
                </>
              )}
            </form>
          </div>

          {this.state.countnews !== 0 ? (
            <NewsList
              items={this.state.news}
              previewCount={3}
              moreHref={`${process.env.REACT_APP_BASENAME || ""}/News/${param}`}
            />
          ) : null}
        </div>
      </>
    );
  }
}


